document.addEventListener('DOMContentLoaded', () => {
  const videoPlayers = document.querySelectorAll('.video-carousel__player');
  videoPlayers.forEach(player => {
    const elements = {
      container: player.querySelector('.video-carousel__container'),
      video: player.querySelector('.video-carousel__video'),
      gifCover: player.querySelector('.video-carousel__gif-cover'),
      thumbnail: player.querySelector('.video-carousel__thumbnail'),
      playButton: player.querySelector('.video-carousel__play-btn')
    };

    if (!elements.video || !elements.playButton || !elements.container) return;

    let isPlaying = false;

    const showCovers = () => {
      elements.gifCover?.classList.remove('hidden');
      elements.thumbnail?.classList.remove('hidden');
      elements.playButton.classList.remove('hidden');
    };

    const hideCovers = () => {
      elements.gifCover?.classList.add('hidden');
      elements.thumbnail?.classList.add('hidden');
      elements.playButton.classList.add('hidden');
    };

    const resetVideo = () => {
      elements.video.pause();
      elements.video.currentTime = 0;
      showCovers();
      isPlaying = false;
    };

    const togglePlay = async () => {
      try {
        if (elements.video.paused) {
          await elements.video.play();
          hideCovers();
          isPlaying = true;
        } else {
          elements.video.pause();
          elements.playButton.classList.remove('hidden');
          isPlaying = false;
        }
      } catch (error) {
        console.error('Error toggling video playback:', error);
        showCovers();
        isPlaying = false;
      }
    };

    const handleClick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      togglePlay();
    };

    resetVideo();

    elements.playButton.addEventListener('click', handleClick);
    elements.container.addEventListener('click', handleClick);

    elements.video.addEventListener('play', () => {
      isPlaying = true;
      elements.playButton.classList.add('hidden');
    });

    elements.video.addEventListener('pause', () => {
      if (isPlaying) {
        elements.playButton.classList.remove('hidden');
      }
    });

    elements.video.addEventListener('ended', () => {
      elements.video.currentTime = 0;
      elements.video.play().catch(() => {
        resetVideo();
      });
    });

    elements.video.addEventListener('error', (e) => {
      console.error('Video failed to load:', e.target.error);
      resetVideo();
    });

    elements.video.addEventListener('loadeddata', resetVideo);
  });
});